export const PRIMARY_DISPLAY = 'primary';
